import Field from "./Field";
import Input from "./Input";

function Phone({
  className,
  errorFormatMessage,
  errorMessage,
  fieldName,
  inputClassName,
  label,
  onBlur,
  requiredPlaceholder,
}: {
  className?: string;
  errorFormatMessage: string;
  errorMessage?: string;
  fieldName: string;
  inputClassName?: string;
  label: string;
  onBlur?: () => void;
  requiredPlaceholder?: string;
}) {
  return (
    <Field
      className={className}
      errorMessage={errorMessage}
      fieldControl={(value, onChange, inError, onBlur) => (
        <Input
          autoComplete="tel"
          className={inputClassName ?? "w-64"}
          inError={inError}
          onBlur={onBlur}
          onChange={onChange}
          required={Boolean(errorMessage)}
          requiredPlaceholder={requiredPlaceholder}
          type="tel"
          value={value ? String(value) : ""}
        />
      )}
      fieldName={fieldName}
      fieldValidations={{
        required: errorMessage,
        validate: (value) =>
          !value || value.replace(/\D/g, "").length >= 8 || errorFormatMessage,
      }}
      label={label}
      onBlur={onBlur}
    />
  );
}

export default Phone;
